
import { BaseTableColumnWidget, OioColumn, OioCommonProps, OioMetadataProps, OioTable, RowContext, TableSize, translate } from '@kunlun/dependencies';
import { OioInput, OioModal } from '@kunlun/vue-ui-antd';
import { defineComponent, PropType, ref, watch } from 'vue';

export default defineComponent({
  name: 'ContinuationInput',
  components: {
    OioInput,
    OioModal,
    OioTable,
    OioColumn
    // DefaultVNodes: (_, { attrs }) => {
    //   const { context, columnWidget } = attrs;
    //   return (columnWidget as BaseTableColumnWidget).renderDefaultSlot(context as RowContext);
    // }
  },
  inheritAttrs: false,
  props: {
    ...OioCommonProps,
    ...OioMetadataProps,
    value: {
      type: String
    },
    onEnter: {
      type: Function
    },
    changeVisble: {
      type: Function
    },
    showDialog: {
      type: Boolean
    },
    tableData: {
      type: Object as PropType<Record<string, unknown>[]>
    },
    setRowClassName: {
      type: Function
    },
    dblclick: {
      type: Function
    },
    checkboxChange: {
      type: Function
    },
    editActived: {
      type: Function
    },
    editClosed: {
      type: Function
    },
    tableKey: {
      type: Number,
      default: 0
    },
    columns: {
      type: Array as PropType<BaseTableColumnWidget[]>
    }
  },
  setup(props) {
    const onEnter = (event) => {
      props.onEnter?.();
    };

    return {
      onEnter,
      translate,
      TableSize
    };
  }
});
